/** Socket event names for the notification feature — single source shared by every listener. */
export const NOTIFICATION_EVENTS = {
  NEW: 'notification:new',
} as const;
